import axios from 'axios'

const state = {
  cycles: []
}

const getters = {
  allCycles: state => state.cycles
}

const actions = {

}

const mutations = {

}

export default {
  state,
  getters,
  actions,
  mutations
}